export default {
  name: 'nb-no',
  el: {
    colorpicker: {
      confirm: 'OK',
      clear: 'Tøm',
    },
    datepicker: {
      now: 'Nå',
      today: 'I dag',
      cancel: 'Avbryt',
      clear: 'Tøm',
      confirm: 'OK',
      selectDate: 'Velg dato',
      selectTime: 'Velg tidspunkt',
      startDate: 'Startdato',
      startTime: 'Starttidspunkt',
      endDate: 'Sluttdato',
      endTime: 'Sluttidspunkt',
      prevYear: 'I fjor',
      nextYear: 'Neste år',
      prevMonth: 'Forrige Måned',
      nextMonth: 'Neste Måned',
      year: '',
      month1: 'Januar',
      month2: 'Februar',
      month3: 'Mars',
      month4: 'April',
      month5: 'Mai',
      month6: 'Juni',
      month7: 'Juli',
      month8: 'August',
      month9: 'September',
      month10: 'Oktober',
      month11: 'November',
      month12: 'Desember',
      week: 'uke',
      weeks: {
        sun: 'Søn',
        mon: 'Man',
        tue: 'Tir',
        wed: 'Ons',
        thu: 'Tor',
        fri: 'Fre',
        sat: 'Lør',
      },
      months: {
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Apr',
        may: 'Mai',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Okt',
        nov: 'Nov',
        dec: 'Des',
      },
    },
    select: {
      loading: 'Laster',
      noMatch: 'Ingen samsvarende resulater',
      noData: 'Ingen resulater',
      placeholder: 'Velg',
    },
    cascader: {
      noMatch: 'Ingen samsvarende resultater',
      loading: 'Laster',
      placeholder: 'Velg',
      noData: 'Ingen resultater',
    },
    pagination: {
      goto: 'Gå til',
      pagesize: '/side',
      total: 'Total {total}',
      pageClassifier: '',
      page: 'Page', // to be translated
      prev: 'Go to previous page', // to be translated
      next: 'Go to next page', // to be translated
      currentPage: 'page {pager}', // to be translated
      prevPages: 'Previous {pager} pages', // to be translated
      nextPages: 'Next {pager} pages', // to be translated
    },
    messagebox: {
      confirm: 'OK',
      cancel: 'Avbryt',
      error: 'Ugyldig input',
    },
    upload: {
      deleteTip: 'trykk på x for å slette',
      delete: 'Slett',
      preview: 'Forhåndsvisning',
      continue: 'Fortsett',
    },
    table: {
      emptyText: 'Ingen Data',
      confirmFilter: 'Bekreft',
      resetFilter: 'Tilbakestill',
      clearFilter: 'Alle',
      sumText: 'Sum',
    },
    tree: {
      emptyText: 'Ingen Data',
    },
    transfer: {
      noMatch: 'Ingen samsvarende data',
      noData: 'Ingen data',
      titles: ['Liste 1', 'Liste 2'],
      filterPlaceholder: 'Skriv inn nøkkelord',
      noCheckedFormat: '{total} gjenstander',
      hasCheckedFormat: '{checked}/{total} valgt',
    },
    image: {
      error: 'FEILET',
    },
    pageHeader: {
      title: 'Tilbake',
    },
    popconfirm: {
      confirmButtonText: 'Ja',
      cancelButtonText: 'Nei',
    },
  },
}
